export default __webpack_public_path__ + "static/media/ethereum-logo-transp.9f197e76.png";